/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WYSIWYGViewerWithFeatureFlag_organization$ref: FragmentReference;
declare export opaque type WYSIWYGViewerWithFeatureFlag_organization$fragmentType: WYSIWYGViewerWithFeatureFlag_organization$ref;
export type WYSIWYGViewerWithFeatureFlag_organization = {|
  +isWysiwygEnabled: boolean,
  +$refType: WYSIWYGViewerWithFeatureFlag_organization$ref,
|};
export type WYSIWYGViewerWithFeatureFlag_organization$data = WYSIWYGViewerWithFeatureFlag_organization;
export type WYSIWYGViewerWithFeatureFlag_organization$key = {
  +$data?: WYSIWYGViewerWithFeatureFlag_organization$data,
  +$fragmentRefs: WYSIWYGViewerWithFeatureFlag_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WYSIWYGViewerWithFeatureFlag_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isWysiwygEnabled",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '4175b6eb1b7b45b41d6af4c23cf8ac29';

module.exports = node;
